export const prizesEnum = {
  GRAND: 'GRAND',
  MONTHLY: 'MONTHLY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
}

export const prizesTranslationMap = {
  [prizesEnum.GRAND]: 'home_carousel_grand',
  [prizesEnum.MONTHLY]: 'home_carousel_month',
  [prizesEnum.DAILY]: 'home_carousel_day',
  [prizesEnum.WEEKLY]: 'home_carousel_week',
}

export const prizeDisplayModeEnum = {
  SINGLE: 'SINGLE',
  CAROUSEL: 'CAROUSEL',
}



// WEBPACK FOOTER //
// ./src/constants/prizes.js